export enum IdentificationType {
  UsSocial = 'USSocial',
  UsEmployer = 'USEmployer',
  CanadaSocial = 'CanadaSocial',
  Other = 'Other',
}
